import producerProductService, { ENDPOINTS } from '@/services/producerProductService';
import moduleFactory from '@/store/modules/moduleFactory';

const moduleStore = moduleFactory.build(ENDPOINTS, producerProductService);

export default {
    namespaced: true,
    state: {
        ...moduleStore.state,
    },
    getters: {
        ...moduleStore.getters,
    },
    mutations: {
        ...moduleStore.mutations,
    },
    actions: {
        ...moduleStore.actions,
    },
};
